export default "__VITE_PUBLIC_ASSET__d011c8fd__"